import { i18n } from 'i18n';

import { TRANSFORM_LOCALE } from './transformLocale';

export const formatNumber = (number: string | number) => {
	if (isNaN(Number(number))) {
		console.error(`formatNumber: The passed string "${number}" is not a number`);
		return null;
	}

	return Number(number).toLocaleString(TRANSFORM_LOCALE[i18n.language]);
};
